/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ChangeEvent, Dispatch, SetStateAction } from 'react';

import { AddEmailModalContainer } from '../styles';
import MyModal from '../../../../../../../../components/Modal';
import FormGroup from '../../../../../../../../components/FormGroup';
import Input from '../../../../../../../../components/Input';

interface AddEmailModalInterface {
  addEmailModalShow: boolean;
  emailToAdd: string;
  handleEmailToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  setAddEmailModalShow: Dispatch<SetStateAction<boolean>>;
  addEmail: () => void;
  emailOwnerName: string;
  handleEmailOwnerNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function AddEmailModal({
  addEmailModalShow,
  emailToAdd,
  handleEmailToAddChange,
  setAddEmailModalShow,
  addEmail,
  emailOwnerName,
  handleEmailOwnerNameChange,
}: AddEmailModalInterface) {
  return (
    <MyModal
      show={addEmailModalShow}
      title="Adicionar e-mail"
      modalBody={(
        <AddEmailModalContainer>
          <FormGroup>
            <label htmlFor="dayDisable">E-mail</label>
            <Input
              value={emailToAdd}
              onChange={handleEmailToAddChange}
              placeholder='Informe um e-mail válido'
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="dayDisable">Nome</label>
            <Input
              value={emailOwnerName}
              onChange={handleEmailOwnerNameChange}
              placeholder='Informe o nome do destinatário deste e-mail'
            />
          </FormGroup>
        </AddEmailModalContainer>
      )}
      closeButtonLabel="Fechar"
      actionButtonLabel="Adicionar"
      onClose={() => setAddEmailModalShow(false)}
      onAction={() => addEmail()}
      isActionButtonDisabled={!emailToAdd || !emailOwnerName}
      type="action"
    />
  );
}
